import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './modules/core/Login';
import Dashboard from './modules/core/Dashboard';
import InventoryList from './modules/inventory/InventoryList';
import ManufacturingScreen from './modules/manufacturing/ManufacturingScreen';
import InventoryDashboard from './modules/inventory/InventoryDashboard';
import WorkOrderForm from './modules/manufacturing/WorkOrderForm';
import WorkOrderList from './modules/manufacturing/WorkOrderList';
import JobSheet from './modules/manufacturing/JobSheet';
import { NotificationProvider } from './context/NotificationProvider';
import BoMForm from './modules/manufacturing/BoMForm';
import BoMList from './modules/manufacturing/BoMList';
import AddProductForm from './modules/inventory/AddProductForm';
import UnderDevelopment from './modules/core/UnderDevelopment';
import JobCardList from './modules/manufacturing/JobCardList';
import JobCardForm from './modules/manufacturing/JobCardForm';
import EmployeeList from './modules/hr/EmployeeList';
import PerformanceList from './modules/hr/PerformanceList';
import RecruitmentList from './modules/hr/RecruitmentList';
import ShiftAndAttendance from './modules/hr/ShiftAndAttendance';
import ExpenseClaims from './modules/hr/ExpenseClaims';
import HRDashboard from './modules/hr/HRDashboard';
import Leaves from './modules/hr/Leaves';
import StockEntries from './modules/manufacturing/StockEntries';
import DowntimeEntries from './modules/manufacturing/DowntimeEntries';

const App: React.FC = () => {
  return (
    <NotificationProvider>

      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/inventory" element={<InventoryDashboard />} />
          <Route path="/inventory/products" element={<InventoryList />} />
          <Route path="/inventory/products/add-product" element={<AddProductForm />} />
          <Route path="/inventory/products/:id" element={<AddProductForm />} />
          <Route path="/manufacturing/work-order" element={<WorkOrderList />} />
          <Route path="/manufacturing/work-order/add-work-order" element={<WorkOrderForm />} />
          <Route path="/manufacturing/work-order/:id" element={<WorkOrderForm />} />
          <Route path="/manufacturing" element={<ManufacturingScreen />} />
          <Route path="/manufacturing/job-sheets/:id" element={<JobSheet />} />
          <Route path="/manufacturing/boms" element={<BoMList />} />
          <Route path="/manufacturing/add-bom" element={<BoMForm />} />
          <Route path="/manufacturing/boms/:id" element={<BoMForm />} />
          <Route path="/manufacturing/job-cards" element={<JobCardList />} />
          <Route path="/manufacturing/downtime-entries" element={<DowntimeEntries />} />
          <Route path="/manufacturing/stock-entries" element={<StockEntries />} />
          <Route path="/manufacturing/job-cards/add" element={<JobCardForm />} />
          <Route path="/under-development" element={<UnderDevelopment />} />
          <Route path="/hr/employees" element={<EmployeeList />} />
          <Route path="/hr/performance" element={<PerformanceList />} />
          <Route path="/hr/recruitment" element={<RecruitmentList />} />
          <Route path="/hr/shift-attendance" element={<ShiftAndAttendance />} />
          <Route path="/hr/expense-claims" element={<ExpenseClaims />} />
          <Route path="/hr/leaves" element={<Leaves />} />
          <Route path="/hr" element={<HRDashboard />} />
        </Routes>
      </BrowserRouter>
    </NotificationProvider>
  );
};

export default App;
